import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { isHXApp } from "@saas/components/src";
import { getWxMiniProgramUrl } from "@saas/server-api/src/product-details";
/**
 *  支付宝支付h5
 * @param {Object} data
 */
export function openAlipay(data) {
  const charges = (data.charges?.data || []).find(
    (item) => item.credential && item.credential.yeepay_alipay_qr
  );
  let { credential = {} } = charges || {};
  console.log("credential>>>>", credential);

  // let { credential = {} } = data.charges.data[0] || {};
  const orderUrl = credential.yeepay_alipay_qr;
  if (orderUrl) {
    const scheme = `alipays://platformapi/startapp?saId=10000007&qrcode=${orderUrl}`;
    window.location.href = scheme;
    // jsToFlutter("alipay", {
    //   scheme,
    // });
  } else {
    throw new Error("缺少yeepay_alipay_qr");
  }
}

function loadURL(url) {
  var iFrame;
  iFrame = document.createElement("iframe");
  iFrame.setAttribute("src", url);
  iFrame.setAttribute("style", "display:none;");
  iFrame.setAttribute("height", "0px");
  iFrame.setAttribute("width", "0px");
  iFrame.setAttribute("frameborder", "0");
  document.body.appendChild(iFrame);
  // 发起请求后这个iFrame就没用了，所以把它从dom上移除掉
  iFrame.parentNode.removeChild(iFrame);
  iFrame = null;
}
export function openWxMiniProgram(data) {
  // webview通知native, 传参数是data json字符串，native端拦截openWxMiniProgram，解析data，调起小程序
  // const { appId, miniProgramOrgId, miniProgramPath, prePayTn } = data;
  if (isHXApp()) {
    // appp 打开支付
    console.log("wxpay===========", data);
    jsToFlutter("wxpay", data);

    return;
  } else {
    location.href = data;
  }
  // loadURL(
  //   `haleyAction://wxMiniProgramPay?appId=${appId}&miniProgramOrgId=${miniProgramOrgId}&miniProgramPath=${miniProgramPath}&prePayTn=${encodeURIComponent(prePayTn)}`
  // );
}
